import { render, staticRenderFns } from "./_base-segmented-tabs.vue?vue&type=template&id=c6938bb4&scoped=true&"
import script from "./_base-segmented-tabs.vue?vue&type=script&lang=js&"
export * from "./_base-segmented-tabs.vue?vue&type=script&lang=js&"
import style0 from "./_base-segmented-tabs.vue?vue&type=style&index=0&id=c6938bb4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6938bb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6938bb4')) {
      api.createRecord('c6938bb4', component.options)
    } else {
      api.reload('c6938bb4', component.options)
    }
    module.hot.accept("./_base-segmented-tabs.vue?vue&type=template&id=c6938bb4&scoped=true&", function () {
      api.rerender('c6938bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-segmented-tabs.vue"
export default component.exports